var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExecutions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1734622047782,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 99745,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 22C241.38 22 22 241.38 22 512s219.38 490 490 490 490-219.38 490-490S782.62 22 512 22z m166.21 533.29h-0.02l-240.7 160.47a52.004 52.004 0 0 1-53.45 2.59 51.972 51.972 0 0 1-27.43-45.94v-320.8a51.994 51.994 0 0 1 27.42-45.96 52 52 0 0 1 53.46 2.58l240.72 160.48A52.016 52.016 0 0 1 701.4 512a52.04 52.04 0 0 1-23.19 43.29z",
    fill: "currentColor",
    "p-id": 99746
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutions);
export default __webpack_public_path__ + "static/media/executions.68efa109300e8df6528e8c8f3f1d1900.svg";
export { ForwardRef as ReactComponent };